import script from "./EventSearchWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSearchWidget.vue?vue&type=script&setup=true&lang=js"

import "./EventSearchWidget.vue?vue&type=style&index=0&id=f2192de6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2192de6"]])

export default __exports__